import { useRef } from 'react';

const CMDS: Array<{ cmd: string; val?: string; title: string; label: React.ReactNode; sep?: boolean }> = [
  { cmd: 'bold', title: 'Bold', label: <b>B</b> },
  { cmd: 'italic', title: 'Italic', label: <i>I</i> },
  { cmd: 'underline', title: 'Underline', label: <u>U</u> },
  { cmd: 'insertUnorderedList', title: 'Bulleted list', label: '•', sep: true },
  { cmd: 'insertOrderedList', title: 'Numbered list', label: '1.' },
  { cmd: 'createLink', title: 'Insert link', label: '↗' },
  { cmd: 'removeFormat', title: 'Clear formatting', label: '⨯', sep: true },
];

/** Rich-text editor for every report field (contenteditable + toolbar). Uncontrolled. */
export function RichEditor({ html, placeholder, compact, onTextChange }:
  { html?: string; placeholder?: string; compact?: boolean;
    /** Fired on every input AND on blur with the current PLAIN text (Q16 sync). */
    onTextChange?: (plain: string, done: boolean) => void }) {
  const areaRef = useRef<HTMLDivElement>(null);
  // UNCONTROLLED after mount: re-applying html on re-render would reset the
  // contentEditable DOM and throw the caret to position 0 on every keystroke
  // (text comes out reversed). The prop only seeds the FIRST render; parents
  // remount (key/conditional render) when they need a different seed.
  const initialHtml = useRef(html ?? '').current;
  function run(cmd: string, val?: string | null) {
    let arg = val ?? null;
    if (cmd === 'createLink') { arg = window.prompt('Link URL:', 'https://'); if (!arg) return; }
    areaRef.current?.focus();
    document.execCommand(cmd, false, arg ?? undefined);
  }
  return (
    <div className={`rte${compact ? ' sm' : ''}`}>
      <div className="rte-toolbar" role="toolbar" aria-label="Formatting">
        {CMDS.map((c, i) => (
          <span key={i} style={{ display: 'contents' }}>
            {c.sep && <span className="rte-sep" />}
            <button type="button" className="rte-b" title={c.title} onMouseDown={(e) => { e.preventDefault(); run(c.cmd, c.val); }}>{c.label}</button>
          </span>
        ))}
      </div>
      <div
        ref={areaRef}
        className="rte-area"
        contentEditable
        suppressContentEditableWarning
        spellCheck
        data-placeholder={placeholder ?? ''}
        dangerouslySetInnerHTML={{ __html: initialHtml }}
        onInput={() => onTextChange?.(areaRef.current?.textContent ?? '', false)}
        onBlur={() => onTextChange?.(areaRef.current?.textContent ?? '', true)}
      />
    </div>
  );
}
